/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize EducationalMaterial Categories View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './eventReportTypesView';

export const mapStateToPropsEventReportTypes = mapStateToProps;
export const mapDispatchToPropsEventReportTypes = mapDispatchToProps;

export default connect(
  mapStateToPropsEventReportTypes,
  mapDispatchToPropsEventReportTypes
)(View);
